import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { UserContext } from "../reuseableComponents/auth/UserContext";
import SecureModuleIndex from "../secure/SecureModuleIndex";
import bgImage from "../../images/loginBackgrounds/unsplash.png";
import bgBottom from "../../images/loginBackgrounds/bottom-mtn.png";
import mtnLogo from "../../images/DEQ_Logos/Mountain-Logo-Utah-DW-2.svg";
import { useLazyQuery } from "@apollo/client";
import { GET_ALL_WATER_SYSTEMS, GET_ALL_INSTITUTIONS, GET_ALL_LHD } from "../../queries/publicQrys/UserAccessQrys";
import { Button, MultiSelect, MultiSelectOption, Modal, ModalTitle, ModalContent, ModalFooter } from "@utahdts/utah-design-system";
import "./PortalAccessForm.css";
import { useMutation } from "@apollo/client";
import { REQUEST_ACCESS } from "../../queries/publicQrys/UserAccessQrys";
import RequestAccessSuccess from "./RequestAccessSuccess";

const PortalAccessForm = (props) => {
    const [accountName, setAccountName] = useState("");
    const [accountNameError, setAccountNameError] = useState(false);
    const [accountDescription, setAccountDescription] = useState("");
    const [accountDescriptionError, setAccountDescriptionError] = useState(false);

    const [waterSystems, setWaterSystems] = useState([]);
    const [getWaterSystems, waterSystemsResult] = useLazyQuery(GET_ALL_WATER_SYSTEMS);

    const [institutionTypes, setInstitutionTypes] = useState([]);
    const [getInstitutionTypes, InstitutionTypesResult] = useLazyQuery(GET_ALL_INSTITUTIONS);

    const [lhdTypes, setLHDTypes] = useState([]);
    const [getLHDTypes, lhdTypeResult] = useLazyQuery(GET_ALL_LHD);

    // State to store selected values
    const [selectedWaterSystems, setSelectedWaterSystems] = useState([]);
    const [selectedInstitutions, setSelectedInstitutions] = useState([]);
    const [selectedLhds, setSelectedLhds] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);
    const [requestAccess, { data, reset }] = useMutation(REQUEST_ACCESS, {
        onError: (error) => {
            setErrorMessage(`${error.name}: ${error.message}`);
          },
          onCompleted: () => {
            if (data.requestAccess === false) {
              setErrorMessage("An unknown error occurred. Please try again.");
            } 
          }
    });

    useEffect(() => {
        Promise.all([
            getWaterSystems(),
            getInstitutionTypes(),
            getLHDTypes()
        ])
            .then(([waterSystemsResult, InstitutionTypesResult, lhdTypeResult]) => {
                if (waterSystemsResult.data && waterSystemsResult.data.getWaterSystemMenu) {
                    setWaterSystems(waterSystemsResult.data.getWaterSystemMenu);
                }
                if (InstitutionTypesResult.data && InstitutionTypesResult.data.getAllInstitutions) {
                    setInstitutionTypes(InstitutionTypesResult.data.getAllInstitutions);
                }
                if (lhdTypeResult.data && lhdTypeResult.data.getAllLHD) {
                    setLHDTypes(lhdTypeResult.data.getAllLHD);
                }
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, [getWaterSystems, getInstitutionTypes, getLHDTypes]);

    const { user } = useContext(UserContext);

    const buttonStyle = {
        margin: "10px",
        borderRadius: "20px",
        cursor: "pointer",
        fontSize: "16px",
    };

    const buttonContainerStyle = {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        marginTop: "20px"
    };

    const bottomSectionStyle = {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundImage: `url(${bgBottom})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        paddingTop: "120px"
    };

    const bottomContentStyle = {
        width: "70%",
        color: "#157995",
        fontSize: "18px",
        display: "flex",
        flexDirection: "column"
    };

    const formStyle = {
        width: "100%",
        maxWidth: "100%",
        margin: "0 auto",
        justifyContent: "center",
        alignItems: "center",
    };

    const formGroupStyle = {
        paddingBottom: "20px"
      };

    const handleWaterSystemChange = (selectedValues) => {
        setSelectedWaterSystems(selectedValues);
    };

    const handleLHDChange = (selectedValues) => {
        setSelectedLhds(selectedValues);
    };

    const handleInstChange = (selectedValues) => {
        setSelectedInstitutions(selectedValues);
    };

    const handleCancelClick = (event) => {
        window.location.href = '/public/request-access'
    }

    const handleCloseErrorModal = () => {
        setErrorMessage(null);
        reset();
    }

    const handleAccountNameChange = (e) => {
        const value = e.target.value;
        setAccountName(value);
      
        // Check if the input is valid
        if (value.trim() === "") {
          setAccountNameError(true); // Set error if the field is empty
        } else {
          setAccountNameError(false); // Clear error if the field is valid
        }
    };

    const handleAccountDescriptionChange = (e) => {
        const value = e.target.value;
        setAccountDescription(value);
      
        // Check if the input is valid
        if (value.trim() === "") {
          setAccountDescriptionError(true); // Set error if the field is empty
        } else {
          setAccountDescriptionError(false);// Clear error if the field is valid
        }
    };

    const onSubmit = (event) => {
        if(accountName === "") {
            setAccountNameError(true);
            return;
        }
        if(accountDescription === "") {
            setAccountDescriptionError(true);
            return;
        }
        const userRequest = {
          umd_id: user.umdId,
          requestAccessType: "portal",
          accountName: accountName,
          accountDescription: accountDescription,
          assignedSystems: selectedWaterSystems.map(systemName => {
            const system = waterSystems.find(ws => ws.label === systemName)
            return { systemId: system.value, systemName: system.label }
          }),
          assignedLhds: selectedLhds.map(lhdName => {
            const lhd = lhdTypes.find(lt => lt.lhd_name === lhdName);
            return { lhd_id: lhd.lhd_id, lhd_name: lhd.lhd_name }
          }),
          assignedInstitutions: selectedInstitutions.map(instName => {
            const inst = institutionTypes.find(it => it.institutionName === instName);
            return { institutionId: inst.institutionId, institutionName: inst.institutionName }
          })
        }
    
        requestAccess({
          variables: {
            input: userRequest,
          },});
      }

    if (waterSystemsResult.loading || InstitutionTypesResult.loading || lhdTypeResult.loading) {
        return <div>loading..</div>
    }

    return (
        <>
            {user.isPublic ? (
                <div className="utah-design-system" >
                    <Row>
                        <Col>
                            <div id="landingPageContainer">
                                <div style={{ display: "flex", flexDirection: "column", width: "100%", maxWidth: "100vw", backgroundImage: `url(${bgImage})`, backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
                                    <div style={{ paddingBottom: "80px", alignItems: "center" }}>
                                        <div style={{ textAlign: "center", maxWidth: "60%", margin: "auto" }}>
                                            <img src={mtnLogo} alt='Mountain Logo' style={{ maxWidth: "100%", objectFit: "contain" }} />
                                        </div>
                                        <br />
                                        <p style={{ maxWidth: "80%", textAlign: "center", fontWeight: "bold", fontSize: "42px", color: "#fff", margin: "auto", objectFit: "contain" }}>
                                            Request Access Portal
                                        </p>
                                        <br />
                                    </div>
                                    <div style={bottomSectionStyle}>
                                    {errorMessage && (
                                        <div className="utah-design-system">
                                            <Modal
                                            ariaLabelledBy="access-request-failure"
                                            className="modal--medium center"
                                            id="modal-example"
                                            >
                                            <ModalTitle id="access-request-failure">
                                                Something went wrong
                                            </ModalTitle>
                                            <ModalContent>
                                                {errorMessage}
                                            </ModalContent>
                                            <ModalFooter className="flex float-right flex-wrap">
                                                <Button onClick={handleCloseErrorModal}>Close</Button>
                                            </ModalFooter>
                                            </Modal>
                                        </div>
                                    )}
                                    {data?.requestAccess === true ? (<RequestAccessSuccess/>) : (
                                        <div style={bottomContentStyle}>
                                            <div style={buttonContainerStyle}>
                                                <Form style={formStyle}>
                                                    <Row className="justify-content-center"> {/* Wrap the fields in a Row */}
                                                        <Col xs={6}> {/* Account Name column */}
                                                            <Form.Group controlId="accountName" style={formGroupStyle}>
                                                                <Form.Label style={{ display: 'block' }}> Account Name</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    style={{ width: "100%" }}
                                                                    value={accountName}
                                                                    onChange={handleAccountNameChange}
                                                                    isInvalid={accountNameError}
                                                                />
                                                                <Form.Control.Feedback type="invalid">
                                                                    Account Name is required.
                                                                </Form.Control.Feedback>
                                                            </Form.Group>

                                                            <Form.Group controlId="waterSystems" style={formGroupStyle}>
                                                                <MultiSelect
                                                                    id="waterSystems"
                                                                    label="Water Systems"
                                                                    onChange={handleWaterSystemChange}
                                                                    values={selectedWaterSystems}
                                                                    className="access-form-multiselect"
                                                                    placeholder="Select Water Systems"
                                                                    autocomplete="off"
                                                                >{waterSystems.map((ws) => (
                                                                    <MultiSelectOption
                                                                        key={ws.value}
                                                                        label={ws.label}
                                                                        value={ws.label}
                                                                    />
                                                                ))}
                                                                </MultiSelect>
                                                            </Form.Group>
                                                        </Col>

                                                        <Col xs={6}> {/* Account Description column */}
                                                            <Form.Group controlId="accountDescription" style={formGroupStyle}>
                                                                <Form.Label style={{ display: 'block'}}>
                                                                    Account Description/Justification
                                                                </Form.Label>
                                                                <Form.Control
                                                                    as="textarea"
                                                                    rows={3}
                                                                    style={{ width: "100%" }}
                                                                    value={accountDescription}
                                                                    onChange={handleAccountDescriptionChange}
                                                                    isInvalid={accountDescriptionError}
                                                                />
                                                                <Form.Text className="text-muted" style={{ display: 'block', textAlign: 'right' }}>
                                                                    {accountDescription.length}/255
                                                                </Form.Text>
                                                                <Form.Control.Feedback type="invalid">
                                                                    Account Description is required.
                                                                </Form.Control.Feedback>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xs={6}>
                                                            <Form.Group controlId="localHealthDepartments" style={formGroupStyle}>
                                                                <MultiSelect
                                                                    id="lhd"
                                                                    label="Local Health Departments"
                                                                    onChange={handleLHDChange}
                                                                    values={selectedLhds}
                                                                    className="access-form-multiselect"
                                                                    placeholder="Select Health Departments"
                                                                    autocomplete="off"
                                                                >{lhdTypes.map((lhd) => (
                                                                    <MultiSelectOption key={lhd.lhd_id} label={lhd.lhd_name} value={lhd.lhd_name} />
                                                                ))}
                                                                </MultiSelect>
                                                            </Form.Group>
                                                        </Col>

                                                        <Col xs={6}>
                                                            <div style={{ marginTop: '0px' }}> {/* Added marginTop here */}
                                                                <Form.Group controlId="institutionsEntities" style={formGroupStyle}>
                                                                    <MultiSelect
                                                                        id="institutions"
                                                                        label="Institutions/Entities"
                                                                        onChange={handleInstChange}
                                                                        values={selectedInstitutions}
                                                                        className="access-form-multiselect"
                                                                        placeholder="Select Institutions"
                                                                        autocomplete="off"
                                                                    >
                                                                        {institutionTypes.map((gt) => (
                                                                            <MultiSelectOption key={gt.institutionId} label={gt.institutionName} value={gt.institutionName} />
                                                                        ))}
                                                                    </MultiSelect>
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                    </Row>
                                                    <div className="utah-design-system" style={buttonContainerStyle}>
                                                        <Button appearance="outlined" size="large" color="primary" style={buttonStyle} onClick={() => { handleCancelClick() }}>
                                                            Cancel
                                                        </Button>
                                                        <Button appearance="solid" size="large" color="primary" style={buttonStyle} onClick={() => { onSubmit() }} >
                                                            Submit
                                                        </Button>
                                                    </div>
                                                </Form>
                                            </div>
                                        </div>
                                    )}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            ) : (
                <SecureModuleIndex />
            )}
        </>
    );
};
export default PortalAccessForm;